import pulse from "@finn-no/pulse-sdk";

type SelectionFilter = {
	name: string;
	value: string;
	valueId?: string;
};

export function trackSemanticSearchLandingView() {
	pulse.trackPageView({
		type: "View",
		name: "Semantic Search",
		object: {
			id: "RSS_pv01",
			name: "Semantic Search",
			type: "Page",
		},
	});
}

export function trackSemanticSearchResultsView(
	query: string,
	numItems: number,
	suggestion?: string,
	selectionFilters?: SelectionFilter[],
) {
	const suggestionFilters = suggestion
		? [
				{
					name: "Suggestion AI",
					value: suggestion,
				},
			]
		: undefined;

	const allFilters = [...(selectionFilters || []), ...(suggestionFilters || [])];

	pulse.trackPageView({
		type: "View",
		name: "Semantic Search Results",
		object: {
			id: "semantic_search_results:RSS_pv02",
			name: "Semantic Search Results",
			type: "Listing",
			filters: {
				query,
			},
			numItems,
			...(allFilters.length > 0 ? { selectionFilters: allFilters } : {}),
		},
	});
}

export function trackSemanticSearchResultsImpression(query: string, ads: { id: string; heading: string }[]) {
	pulse.trackEvent({
		type: "View",
		intent: "Open",
		name: "Semantic Search Result Viewed",
		object: {
			id: "RSS_ev05",
			type: "UIElement",
			name: "Semantic Search Results",
			filters: {
				query,
			},
			items: ads.map((ad, index) => ({
				id: ad.id,
				type: "ClassifiedAd",
				name: ad.heading,
				rank: index,
				category: "n/a",
				isTopPositionPremiumFeature: false,
			})),
		},
	});
}

export function trackSemanticSearchResultClick(query: string, adId: string, position: number) {
	pulse.trackEvent({
		type: "Click",
		intent: "Open",
		name: "Semantic Search Results",
		object: {
			id: adId,
			type: "ListingItem",
			rank: position,
			filters: {
				query,
			},
		},
	});
}

export function trackSemanticSearchSuggestionsView(query: string, suggestionCount: number) {
	pulse.trackEvent({
		type: "View",
		intent: "Show",
		name: "Semantic Search Suggestions",
		object: {
			id: "RSS_ev07",
			type: "UIElement",
			elementType: "Button",
			filters: {
				query,
			},
			tags: ["AI Suggestions"],
			metrics: {
				count: suggestionCount,
			},
		},
	});
}

export function trackSemanticSearchSuggestionClick(query: string, suggestion: string, order: number) {
	pulse.trackEvent({
		type: "Click",
		intent: "Search",
		name: "Semantic Search Suggestions",
		object: {
			id: "RSS_ev08",
			type: "UIElement",
			elementType: "Button",
			group: "AI Suggestions",
			order,
			filters: {
				query,
			},
			tags: ["AI Suggestions"],
			name: suggestion,
		},
	});
}

export function trackSemanticSearchFeedbackClick(query: string, variant: "positive" | "negative") {
	const label = variant === "positive" ? "Positive" : "Negative";
	pulse.trackEvent({
		type: "Click",
		intent: "Rate",
		name: "Semantic Search Feedback Section",
		object: {
			id: "RSS_ev09",
			type: "UIElement",
			elementType: "Button",
			position: "Feedback",
			name: label,
			tags: ["Feedback"],
			filters: {
				query,
			},
		},
	});
}
